import { Typography } from "@mui/material"
import type { FunctionComponent, ReactNode } from "react"

import type { Product } from "@/graphql/codegen/graphql"
import { TechnicalInformationCasNumbers } from "@/screens/Products/components/Product/Information/TechnicalInformation/TechnicalInformationCasNumber"
import { booleanToYesNoString, isNil } from "@/utils/utils"

interface TechnicalInformationListProps {
  productDetails: Pick<
    Product,
    | "chemicalName"
    | "specificGravity"
    | "shelfLifeMonths"
    | "casRegistryIds"
    | "harmonizedTariffSchedule"
    | "usmcaClass"
    | "unNumber"
    | "hazardStatusUs"
    | "hazardStatusInternational"
  >
}

const renderTechnicalInfoItem = (label: string, value: ReactNode, key: number) => (
  <div key={key} className='flex min-h-[54px] items-center border-b border-gray-500'>
    <Typography variant='body2' className='flex-1 text-left text-gray-900'>
      {label}
    </Typography>
    <Typography variant='body2' className='flex-1 text-left text-sm'>
      {isNil(value) || value === "" ? "-" : value}
    </Typography>
  </div>
)

export const TechnicalInformationList: FunctionComponent<TechnicalInformationListProps> = ({ productDetails }) => {
  const technicalInfoItems = [
    { label: "Chemical Name:", value: productDetails.chemicalName },
    { label: "Specific Gravity:", value: productDetails.specificGravity },
    { label: "Shelf Life (Months):", value: productDetails.shelfLifeMonths },
    {
      label: "CAS:",
      value: <TechnicalInformationCasNumbers casRegistryIds={productDetails.casRegistryIds as string[]} />,
    },
    { label: "HTS:", value: productDetails.harmonizedTariffSchedule },
    { label: "USMCA (NAFTA):", value: productDetails.usmcaClass ? "Selected" : "Not Selected" },
    { label: "UN Number:", value: productDetails.unNumber },
    { label: "Hazard Status: US", value: booleanToYesNoString(productDetails.hazardStatusUs) },
    { label: "Hazard Status: International", value: booleanToYesNoString(productDetails.hazardStatusInternational) },
  ]

  return (
    <div className='mr-20'>
      {technicalInfoItems.map((item, index) => renderTechnicalInfoItem(item.label, item.value, index))}
    </div>
  )
}
